export default __webpack_public_path__ + "fff5d09a2dc51827a9c11996a4d91caa.png";